import React from 'react';
import { DialogNew, Button } from '@optimizely/axiom';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, teamName }) => {
  if (!isOpen) return null;

  return (
    <DialogNew
      isOpen={isOpen}
      title="Confirm Team Deletion"
      testSection="confirm-team-deletion-modal"
      hasCloseButton={true}
      onClose={onClose}
      footerButtonList={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        // eslint-disable-next-line react/style-prop-object
        <Button key="confirm" style="danger" onClick={onConfirm}>
          Delete Team
        </Button>
      ]}
    >
      <p>Are you sure you want to delete team "{teamName}"?</p>
    </DialogNew>
  );
};

export default ConfirmationModal;
